import React, { useState, useEffect, useRef} from 'react';
import { configData } from "../config";
import { useParams } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import './classes/ApplicationImporter.css';

function ApplicationImporter() {

   
    const [isLoading, setIsLoading] = useState(true);
    const[error,setError] = useState({});
    const[success,setSuccess] = useState('');
    const app_url = configData.APP_URL;
    const [selectedFile, setSelectedFile] = useState(null);
    const[sortflagList, setSortflagList] = useState({});
    const[queueList, setQueueList] = useState({});
     const fileInputRef = useRef(null);
    const [importerformData, setImporterFormData] = useState({
      
        sortflags:[],
        reg_step:'',
        schedule_task:'Yes',

      pageURL: window.location.href, 
      });
    const handleChange = event => {
    const { name, value} = event.target;
    setImporterFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  
    
     
    if(event.target.name === 'sortflags') {
      const isChecked = event.target.checked;
      if(isChecked){
      setImporterFormData(prevState => ({
        ...prevState,
        sortflags: [...importerformData.sortflags, event.target.value],
        
      }));
    } else {
      let index = importerformData.sortflags.indexOf(event.target.value);
      importerformData.sortflags.splice(index, 1);
      setImporterFormData(prevState => ({
        ...prevState,
        sortflags: importerformData.sortflags,
        
      }));
    }
    }
   
  };
  async function  retrieveSortFlags() {
    
   try {
    //  setIsLoading(true);
    const response = await fetch(
      app_url+'sortflag/getsortflaglist',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setSortflagList(responsedata.data.result);
    }
  }  catch (error) {
            console.error('Error fetching data:', error);
          // } finally {
          //   setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  }
  async function  retrieveQueuelist() {
    
   try {
    //  setIsLoading(true);
    const response = await fetch(
      app_url+'importer/getqueue',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.msg === "Success") {
      setQueueList(responsedata.data.result);
    }
  }  catch (error) {
            console.error('Error fetching data:', error);
          // } finally {
          //   setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  }
      const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
      };
        const handleUpload = async () => {
          if (!selectedFile) {
            alert('Please select a CSV file first.');
            return;
          }

      const formData = new FormData();
      formData.append('csvFile', selectedFile); // 'csvFile' is the key expected by your backend
      formData.append('importerformData', JSON.stringify(importerformData));
      try {
        setIsLoading(true);
        const response = await fetch( app_url+'importer/applicationimport', {
          method: 'POST',
          body: formData, // Send the FormData object
        });

        if (response.ok) {
          const result = await response.json();
          console.log('Upload successful:', result);
           if(result.data.msg === "Success") {
         
          
          setImporterFormData(prevState => ({
            sortflags:[],
            reg_step: '',
          }));
          setIsLoading(false);
          
          setSuccess(result.data.result);
          setQueueList(result.data.list);
          
          window.scrollTo(0, 0);
           
        } else {
           setError(result.data.result);
            window.scrollTo(0, 0);
           }
        } else {
          console.error('Upload failed:', response.statusText);
          alert('CSV upload failed.');
        }
      } catch (error) {
        console.error('Error during upload:', error);
        
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
      const handleClear = async () => {
        try {
        setIsLoading(true);
        const response = await fetch( app_url+'importer/clearqueue', {
          method: 'POST'
        
        });

        if (response.ok) {
          const result = await response.json();
         
           if(result.data.msg === "Success") {
         
          
          setIsLoading(false);
          
          setSuccess(result.data.result);
          
          
          window.location.reload();
        }
      }
      }catch (error) {
        console.error('Error during upload:', error);
        
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
       };
    // useEffect(()=>{
    //        retrieveSortFlags();
    //        retrieveQueuelist();
    //     },[])
        
    useEffect(() => {
        Promise.all([
           retrieveSortFlags(),
           retrieveQueuelist(),
        ])
        .then(() => {
        setIsLoading(false);
        })
    },[]);    
    
    
     return (
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
 
            <div class="left"></div>

            <div class="center left-center application_importer">
                <Helmet><title>SMWW application import</title></Helmet>
                  {Object.keys(error).length > 0 && (
          <div className="set-message-error">
           {Object.keys(error).map((key, index) => {
           return <>{error[key]}<br /></>
          
        })}  
          </div>
        )}
                {success && (
                    <>
                        <div className="set-message-done">
                        <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                        </div></>
          
                )}
                <h1>Application importer</h1>
                <div class="messages_details">
<p><b>Files(s) must be CSV and have the following columns:</b></p>
<ul>
	
    <li><strong>fname </strong>(First Name)</li>
	<li><strong>lname </strong>(Last Name)</li>
	<li><strong>email</strong></li>
	

</ul>
<p>&nbsp;</p>
<p><b>The following columns are optional:</b></p>
<ul>
<li><strong>dt</strong> (mm/dd/yyyy or m/dd/yyyy)</li>
	<li><strong>phone</strong></li>
	<li><strong>event_log</strong></li>
	<li><strong>linkedin_url</strong></li>
	<li><strong>applied_courses</strong> (case sensitive)</li>
  <li><strong>sms_consent</strong> (TRUE or FALSE)</li>
  
  
</ul>
	
</div>
 {queueList.length > 0 ? (
      <>
        <div class="page-view-myorder">
          <div class="panel panel-default">
            <div class="panel-heading" style={{background:'#fefefe'}}>
              <b>List of users in queue</b>
			       	<a style={{float:'right'}} href onClick={handleClear}><button type="button">Clear</button></a>											 
            </div>
            <div class="panel-body" >
	          <table class="table table-bordered table-striped"><tr><th>Email</th><th>First Name</th><th>Last Name</th><th>Phone no</th><th>Event Log</th><th>Status</th><th>App register Step</th><th>Applied courses</th><th>SMS Consent</th></tr>
           {queueList.map((item, index) => {
                 return <>
                 <tr>
                    <td>{item['email']}</td>
                    <td>{item['fname']}</td>
                    <td>{item['lname']}</td>
                    <td>{item['phone']}</td>
                    <td>{item['event_log']}</td>
                    <td>{item['status']}</td>
                    <td>{item['reg_step']}</td>
                    <td>{item['applied_courses']}</td>
                    <td>{item['sms_consent']}</td>
                    </tr>
                    </>
                    
                    })}  
          </table>
          </div>
          </div></div>
          </>
        ) : (
               <> <b>Import applications:</b> <input type="file" name="file" ref={fileInputRef} accept=".csv" onChange={handleFileChange} />(<a href="/basic/web/application_importer/application_importer_demo.csv">Demo file</a>)&nbsp;&nbsp;&nbsp;(<a href="https://docs.google.com/document/d/16bsZQjer0_WXc1_bN7L54w0fLpMmDW9lIqai9K0IY4I/edit?usp=sharing" target="_blank">Instructions</a>)<br /><br />
                
                <b>App Register Step: </b>
                    <select id="reg_step" name="reg_step" onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select><br/><br/>
                    <b>Scheduled Task Out: </b>
                    <select id="schedule_task" name="schedule_task" onChange={handleChange}>
                        
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        
                    </select><br/><br/>
                    {sortflagList.length > 0 && (
                    <>
                        {sortflagList.map((item, index) => {
                  return (
                    <label key={item['id']} className='importer-sortflag-label'>
                      <input type="checkbox" id="sortflags" name="sortflags" value={item['id']} onChange={handleChange} />{item['name']}&nbsp;&nbsp;
                    </label>
                  )
                    
                  })}  
                    
          </>
        )}
                    
                    <div className="import_button"><button className="form-submit" onClick={handleUpload}>Import</button></div></>
  )}
                
            </div>
        </div>
        
        )}
    </>
    
      );
      
}
export default ApplicationImporter;